import { IItem, instanceOfIItem } from "./IItem";
import { IDrawable, instanceOfIDrawable } from "./IDrawable";
import { IRelayoutable, instanceOfIRelayoutable } from "./IRelayoutable";

export interface IDrawableItem extends IItem, IDrawable, IRelayoutable {
  toolTip: string;
}

export function instanceOfIDrawableItem(instance: any): instance is IDrawableItem {
  return instanceOfIItem(instance)
    && instanceOfIDrawable(instance)
    && instanceOfIRelayoutable(instance);
}
